<template>
  <div class="container" style="padding: 10px">
    <div class="content mt20">

      <div class="container-flex-k">
        <div class="container-leftflex-k">
          <div class="container-leftflextop-k">
            <div> <span>角色名称</span> </div>
            <el-button type="primary" @click="addRole" class="add-bu-k">添加角色</el-button>
          </div>

          <el-alert class="mt10" title="双击角色可编辑" type="warning"></el-alert>

          <el-menu default-active="1" class="mt20" @select="roleSelect">
            <el-menu-item v-for="(item, index) in rolesList" :key="index" :index="item.roleId"
              @mouseenter.native="selectStyle(item)" @mouseleave.native="outStyle(item)"
              @dblclick.native="editRole(item)">
              <span>{{ item.roleNameDisplay }}</span>
              <!--管理员不可删除-->
              <span v-if="item.roleId != 1 && item.isShowDelete">
                <a href="javascript:void(0)" @click="delRole(item.roleId)" title="删除">
                  <i class="el-icon-delete"></i>
                </a>
              </span>
              <span v-if="index > 0 &&  item.isShowDelete">
                <a href="javascript:void(0)" @click="changeOrder(item.roleId,0)" title="上移">
                  <i class="el-icon-top"></i>
                </a>
              </span>
              <span v-if="index != rolesList.length-1 &&   item.isShowDelete">
                <a href="javascript:void(0)" @click="changeOrder(item.roleId,1)" title="下移">
                  <i class="el-icon-bottom"></i>
                </a>
              </span>
            </el-menu-item>
          </el-menu>

        </div>
        <div class="container-rightflex-k">
          <el-button type="primary" @click="saveChange" v-if="isShowButton" :loading="saveChangeLoading"
            class="rightfile-bu-k add-bu-k">保存</el-button>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="用户组成员" name="first">
              <div class="search-box">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item label="搜索：">
                    <el-input
                      v-model="keyword"
                      placeholder="请输入关键字"
                      @keyup.enter.native="searchTo()"
                    ></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button type="primary" @click="searchTo()">查询</el-button>
                  </el-form-item>
              </el-form>
              </div>
              <pagination-table ref="table" :data="customerList" :columns="columns" :loader="fetchRoleCustomer"
                :async="true" :pageSizes="[20]"></pagination-table>
            </el-tab-pane>
            <el-tab-pane label="权限配置" name="second">
              <el-table :data="authority" v-loading="roleTableLoading" 
              row-class-name="table-row-class-name"
              :header-row-style="{
                background: 'transparent',
              }">
                <el-table-column label="操作对象" prop="groupName" width="200">
                  <template slot-scope="scope">
                    <span>{{ scope.row.groupName }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="权限" prop="functionList">
                  <template slot-scope="scope">
                    <el-checkbox-group v-model="checkedFeatures" @change="handleCheckedFeaturesChange(scope)">
                      <el-checkbox v-for="(item, index) in scope.row.functionList" :key="index"
                        :label="item.functionId">{{ item.functionName }}</el-checkbox>
                    </el-checkbox-group>
                  </template>
                </el-table-column>
                <el-table-column label="全选" width="150">
                  <template slot-scope="scope">
                    <el-checkbox @change="handleCheckAllChange(scope)" v-model="scope.row.ionsChecked"
                      :indeterminate="scope.row.isIndeterminate" :key="scope.$index"></el-checkbox>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>

      </div>


    </div>

    <!--新增角色-->
    <el-dialog v-drag:common :visible="dialog.visible" title="角色信息" width="500px" @close="cancelDialog" :show-close="false">
      <el-form :rules="dialog.rule" ref="dialog" :model="dialog.data" label-position="left">
        <!-- <el-row type="flex" justify="space-around" class="mt40"> -->
          <el-form-item prop="roleName">
          <span class="jsname">角色名称</span> <el-input placeholder="请输入角色名称" v-model="dialog.data.roleName" :maxlength="30">
            </el-input>
          </el-form-item>
        <!-- </el-row> -->
        <!-- <el-row class="mb20"> -->
          <el-form-item>
            <div class="lobu-k">
              <el-button @click="cancelDialog" id="quxiao-bu-k">取消</el-button>
              <el-button @click="save()" type="primary" :loading="dialog.loading">确认</el-button>
              
            </div>
            <!-- <el-col :span="12" align="center"> -->
            
            <!-- </el-col> -->
            <!-- <el-col :span="12" align="center"> -->
              
            <!-- </el-col> -->
          </el-form-item>
        <!-- </el-row> -->
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { getToken } from '@/utils';
  export default {
    name: 'role',
    data() {
      return {
        activeName: 'first',
        rolesList: [],
        roleId: '1',
        customerList: [],
        checked: false,
        // 搜索框
        keyword: '',
        columns: [
          {
            prop: 'userCode',
            label: '用户名'
          },
          {
            prop: 'name',
            label: '姓名'
          },
          {
            prop: 'state',
            label: '状态',
            render: (y, scope) => {
              if (scope.row.state === 0) {
                return <span>启用</span>;
              } else {
                return <span>禁用</span>;
              }
            }
          }
        ],
        dialog: {
          visible: false,
          loading: false,
          rule: {
            roleName: [
              {
                required: true,
                message: '请输入角色名称',
                trigger: 'blur'
              }
              // {
              //   validator: (rule, value, callback) => {
              //     if (value.trim()) {
              //       callback();
              //     } else {
              //       callback(new Error('请输入正确的角色名称'));
              //     }
              //   },
              //   trigger: 'blur'
              // }
            ]
          },
          data: {
            roleId: 0,
            roleName: ''
          }
        },
        authority: [],
        roleTableLoading: false,
        checkedAll: false,
        isIndeterminate: false,
        checkedFeatures: [],
        checkedLength: 0,
        checkedList: [],
        saveChangeLoading: false,
        // 是否展示修改按钮
        isShowButton: false,
        isShowSaveButton: false
      };
    },
    watch: {
      roleId() {
        this.checkedFeatures = [];
        this.$refs.table.load({ page: 1 });
        this.fetchRoleCustomer({ page: 0 });
        this.fetchAuthority();
      }
      // checkedFeatures(val) {
      // if (val.length === 0) {
      //   return;
      // }
      // this.isShowSaveButton = true;
      // if (val.length !== this.checkedLength) {
      //   this.isShowSaveButton = true;
      // } else {
      //   let isUse = false;
      //   val.forEach(item => {
      //     isUse = this.checkedList.includes(item);
      //   });
      //   if (!isUse) {
      //     this.isShowSaveButton = true;
      //   } else {
      //     this.isShowSaveButton = false;
      //   }
      // }
      // }
    },
    methods: {
      async fetchRole() {
        await this.$fetch('/windfarm/roleManage/getRoleList', {
          module: 'manage',
          showError: true
        }).then(res => {
          this.rolesList = res.data.defaultParam.map(item => {
            item.roleId = item.roleId.toString();
            item.isShowDelete = false;
            return item;
          });
          this.fetchRoleCustomer({ page: 1 });
          this.fetchAuthority();
        });
      },
      async fetchRoleCustomer(options) {
        const res = await this.$fetch('/windfarm/roleManage/getRoleUserList', {
          params: {
            roleId: this.roleId,
            pageNo: options.page,
            keyword: this.keyword
          },
          module: 'manage',
          showError: true
        });
        if (!res.data.defaultParam) {
          this.customerList = [];
          return;
        }
        this.customerList = res.data.defaultParam.rows;
        return {
          data: res.data.defaultParam && res.data.defaultParam.rows,
          total: res.data.defaultParam && res.data.defaultParam.total
        };
      },
      async fetchAuthority() {
        this.checkedFeatures = [];
        this.checkedList = [];
        this.roleTableLoading = true;
        await this.$fetch('/windfarm/roleManage/getFunction', {
          params: {
            roleId: this.roleId
          },
          module: 'manage',
          showError: true
        })
          .then(res => {
            if (!res.data.defaultParam) {
              this.authority = [];
              this.roleTableLoading = false;
              return;
            }
            this.authority = res.data.defaultParam.map(item => {
              let checkedList = [];
              item.functionList.forEach(val => {
                if (val.status === 1) {
                  this.checkedFeatures.push(val.functionId);
                  checkedList.push(val.functionId);
                }
              });
              this.checkedLength = this.checkedFeatures.length;
              this.checkedList = this.checkedFeatures;
              if (checkedList.length === item.functionList.length) {
                item.isChecked = true;
                item.isIndeterminate = false;
              } else if (
                checkedList.length < item.functionList.length &&
                checkedList.length > 0
              ) {
                item.isChecked = false;
                item.isIndeterminate = true;
              } else {
                item.isChecked = false;
                item.isIndeterminate = false;
              }
              return item;
            });
            this.roleTableLoading = false;
          })
          .catch(e => {
            this.roleTableLoading = false;
            throw e;
          });
      },
      roleSelect(val) {
        this.roleId = val;
      },
      handleClick(val) {
        if (val.name === 'second') {
          this.isShowButton = true;
        } else {
          this.isShowButton = false;
        }
      },
      addRole() {
        this.dialog.visible = true;
        this.dialog.data.roleName = '';
      },
      delRole(val) {
        this.$confirm('此操作将删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$postForm('/windfarm/roleManage/delRole', {
              module: 'manage',
              showError: true,
              showSuccess: true,
              data: {
                roleId: val
              }
            }).then(() => {
              // 重新获取机组数据列表
              this.fetchRole();

               this.fetchRoleCustomer({ page: 1 });
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      },
      changeOrder(roleId, order) {
        this.$postForm('/windfarm/roleManage/roleUpOrDown', {
          module: 'manage',
          showError: true,
          data: {
            roleId: roleId,
            state: order,
          }
        }).then(() => {
          this.fetchRole();
        });
      },
      searchTo() {
        // this.fetchRoleCustomer({ page: 0 });
        this.$refs.table.load({ page: 1 });
      },
      selectStyle(val) {
        let index;
        this.rolesList.forEach((item, i) => {
          if (item.roleId === val.roleId) {
            index = i;
          }
        });
        this.$set(this.rolesList[index], 'isShowDelete', true);
      },
      outStyle(val) {
        this.rolesList.forEach(item => {
          if (item.roleId === val.roleId) {
            item.isShowDelete = false;
          }
        });
      },
      handleCheckAllChange(scope) {
        this.authority.forEach(item => {
          if (scope.row.groupId === item.groupId) {
            if (scope.row.isChecked) {
              scope.row.functionList.forEach(val => {
                if (!this.checkedFeatures.includes(val.functionId)) {
                  this.checkedFeatures.push(val.functionId);
                }
              });
              scope.row.isIndeterminate = false;
            } else {
              scope.row.functionList.forEach(val => {
                val.status = 0;
                this.checkedFeatures.splice(
                  this.checkedFeatures.indexOf(val.functionId),
                  1
                );
              });
            }
          }
        });
        this.isIndeterminate = false;
      },
      handleCheckedFeaturesChange(scope) {
        let newCheckedFeatures = [];
        this.checkedFeatures.forEach(item => {
          for (let i = 0; i < scope.row.functionList.length; i++) {
            if (item === scope.row.functionList[i].functionId) {
              newCheckedFeatures.push(item);
            }
          }
        });
        let checkedCount = newCheckedFeatures.length;
        let checkAll =
          checkedCount === this.authority[scope.$index].functionList.length;
        let isIndeterminate =
          checkedCount > 0 &&
          checkedCount < this.authority[scope.$index].functionList.length;
        let { ...newObj } = scope.row;
        newObj.isIndeterminate = isIndeterminate;
        if (checkedCount >= 0) {
          newObj.isChecked = checkAll ? true : false;
        }
        this.$set(this.authority, scope.$index, newObj);
      },
      cancelDialog() {
        this.dialog.visible = false;
        this.dialog.loading = false;
        this.dialog.data.roleId = 0;
        this.dialog.data.roleName = '';
        if (this.$refs.dialog) {
          this.$refs.dialog.clearValidate();
        }
      },
      editRole(val) {
        if (val.roleId == 1) {
          this.$message({
            type: 'info',
            message: '系统管理员不可编辑'
          });
          return false;
        }
        this.dialog.visible = true;
        this.dialog.data.roleId = val.roleId;
        this.dialog.data.roleName = val.roleName;
      },
      save() {
        this.$refs.dialog.validate().then(() => {
          this.dialog.loading = true;
          let url = `/windfarm/roleManage/saveRole?`;
          let params = `apiKey=${getToken()}&roleId=${this.dialog.data.roleId
            }&roleName=${this.dialog.data.roleName}`;
          url = url + params;
          // 编辑用户
          this.$fetch
            .post({
              url,
              module: 'manage',
              showError: true,
              showSuccess: true
            })
            .then(() => {
              this.dialog.loading = false;
              this.dialog.visible = false;
              return this.fetchRole();
            })
            .catch(() => {
              this.dialog.loading = false;
            });
        });
      },
      saveChange() {
        console.log('222222')
        if (this.roleId == 1) {
          this.$message({
            type: 'info',
            message: '系统管理员-权限配置不能进行操作'
          });
          return false;
        }
        this.saveChangeLoading = true;
        let url = `/windfarm/roleManage/saveRolerFunction?apiKey=${getToken()}&roleId=${this.roleId
          }`;
        let dataList = [];
        this.authority.forEach(arr => {
          for (let i = 0; i < arr.functionList.length; i++) {
            if (this.checkedFeatures.includes(arr.functionList[i].functionId)) {
              dataList.push({
                functionId: arr.functionList[i].functionId,
                roleId: this.roleId,
                status: 1
              });
            } else {
              dataList.push({
                functionId: arr.functionList[i].functionId,
                roleId: this.roleId,
                status: 0
              });
            }
          }
        });
        this.$fetch
          .post({
            url,
            data: {
              roleFunctionList: dataList
            },
            methods: 'posts',
            module: 'manage',
            showError: true,
            showSuccess: true
          })
          .then(() => {
            this.saveChangeLoading = false;
            return this.fetchRole();
          })
          .catch(() => {
            this.saveChangeLoading = false;
          });
      }
    },
    mounted() {
      this.fetchRole();
    },
    // created () {
    //   this.fetchRoleCustomer({ page: 1 });
    // }
  };
</script>

<style lang="less" scoped>
#quxiao-bu-k {
  width: 82px;
  height: 33px;
  border-radius: 5px;
  color: #fff;
  background: #081A29;
  /* display: flex;
  justify-content: space-around; */
}

.lobu-k {
  width: 50%;
  display: flex;
  justify-content: space-around;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
}

.jsname{
  margin-left: 80px;
}


  .container-flex-k {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .container-leftflex-k {
      width: 25%;
      border-radius: 5px;
      border: 1px solid #fff;
      box-sizing: border-box;
      height: 91vh;
      overflow-x: hidden;
      overflow-y: auto;

      .container-leftflextop-k {
        width: 96%;
        height: 45px;

        margin-left: auto;
        margin-right: auto;
        border-bottom: 1px solid #fff;
        margin-bottom: 5px;
        margin-top: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          font-size: 16px;
          margin-left: 23px;
        }
      }

      .mt20 {
        width: 96%;
        margin-left: auto;
        margin-right: auto;
        background-color: rgba(0, 0, 5, 0);
        color: #fff;
      }
    }

    .container-rightflex-k {
      width: 74.5%;
      border-radius: 5px;
      border: 1px solid #fff;
      box-sizing: border-box;
      height: 91vh;
      overflow-x: hidden;
      overflow-y: auto;
      position: relative;
      padding: 10px;


      .rightfile-bu-k {
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 10;
      }


    }

    div /deep/.el-alert--warning.is-light {
      background-color: #081A29;
      color: #fff;
      width: 97%;
      margin-left: auto;
      margin-right: auto;
      height: 40px;
      margin-bottom: 5px;

    }

    div /deep/.el-alert.is-light .el-alert__closebtn {
      color: #fff;
      margin-top: 3px;
    }

    div /deep/.el-menu-item {

      color: #fff;

      &.is-active {
        background-color: #133C62;
      }

      &:hover {
        background-color: #133C62;
      }


    }

    .el-icon-delete
    {
    color: #fff;
    margin-left: 3px;
  }

  .el-icon-top,
  .el-icon-bottom {
    color: #fff;
  }

  }
</style>